import { StartupService } from "./startup.service";

export function AppInitializationFactory(startUpService: StartupService) {
    return () =>startUpService.load();
  }


// WEBPACK FOOTER //
// ./src/app/startup/app-initialization.factory.ts